import { IconProps } from '@/components/svg';

// 用户登录类型
export enum UserLoginType {
  NoLogin = 'noLogin', // 未登录
  VipUser = 'vipUser', // VIP用户
  NotVipUser = 'notVipUser', // 非VIP用户
}

export enum PrivilegesType {
  Advance = 'advance', // 提前观看
  MoreDevice = 'more_device', // 多设备观看
  Exclusive = 'exclusive', // 独家观看
}

export enum ChannelEnum {
  Normal = 'normal', // 普通渠道
  Astro = 'astro', // 星空渠道
}

export interface Privileges {
  type: PrivilegesType;
  // icon: React.FC<IconProps>;
  icon: string;
  content: string;
}

export type HeaderTipEnum = {
  [key in ChannelEnum]: {
    [key in UserLoginType]: string;
  };
};

export type HeaderDearUser = {
  [key in UserLoginType]: string;
};

export type VipOpenContent = {
  [key in ChannelEnum]: {
    openVipQrCode?: boolean;
    openVipQrCodeTip?: string;
    AstroPurchaseVipTitle?: string;
    purchaseVip?: string;
    AstropurchaseVipTip?: string;
  };
};

export enum SourcePageEnum {
  PlayPage = 'playPage', // 播放页
  PlayDetailPage = 'playDetailPage', // 播放详情页
  HomePage = 'homePage', // 个人中心页
  SetUpPage = 'setUpPage', // 设置页
}

export type SourceValEnum = {
  [key in SourcePageEnum]: string;
};

export type VipOpendTips = {
  [key in UserLoginType]: string;
};

export enum VipOpenPageFocusModule {
  PayPageGoLoginBtn = 'payPageGoLoginPageBtn',
  PayPageQrcodeOrPurchaseBtn = 'payPageQrcodeOrPurchaseBtn',
  PayPageAccountMisMatchBtn = 'payPageAccountMisMatchBtn',
  PayResPageOptionBtn = 'payResPageOptionBtn',
}

// 用户信息接口
export interface UserInfo {
  avatar: string;
  nick: string;
  vuid: string;
  loginIcon: React.FC<IconProps> | null;
  expireTime: string;
  endTimestamp: number;
  loginStatus: UserLoginType; // 登录登录状态
}

export interface VipOpenPageStates {
  userInfo: UserInfo | null;
  channelType: ChannelEnum;
  source: string;

  orderGuid: string;
  qrCodeUrl: string | null;
  qrCodeLoading: boolean;
  qrCodeError: boolean;
  timer: number | null;

  isShowSwitchAccountTipPage: boolean;

  isPurchasing: boolean;
  isPurchased: boolean;

  selectModule: VipOpenPageFocusModule | null;
}

export interface VipOpenPageActions {
  reset: () => void;

  setQrCodeErr: () => void;

  getOrderGuid: () => Promise<void>;
  getQrcode: () => Promise<void>;

  getMsgIntl: () => Promise<void>;
  pollGetMsgIntl: () => Promise<void>;
  stopPollGetMsgIntl: () => void;

  fetchQrCode: () => Promise<void>;
  retryFetchQrCode: () => Promise<void>;

  keyToVal: <K extends keyof VipOpenPageSore>(key: K) => VipOpenPageSore[K];
  setKeyVal: <K extends keyof VipOpenPageSore>(key: K, val: VipOpenPageSore[K]) => void;
}

export type VipOpenPageSore = VipOpenPageStates & VipOpenPageActions;
